module.exports = __webpack_public_path__ + "img/76d41ff.jpg";